const permissions = {
  None: "No special permission required",
  GlobalAdmin: "Global Admin",
  AdminOrganisationOnly: "Admin Organisation Only",
  ManageOrganisations: "Manage Organisations",
  ViewLogs: "View Logs",
  OrganisationAdmin: "Organisation Admin",
};
export default permissions;
